'use client';

import ClientComp from './ClientComp';

export default function Content({ data, creditsData, activeType, callback, winCallback, itemCallback }: any) {
    // tab点击切换
    const tabCallback = (item: any) => {
        callback && callback(item);
    };
    return (
        <div className="eco-redeem-rewards-page">
            <ClientComp
                data={data}
                creditsData={creditsData}
                activeType={activeType}
                callback={tabCallback}
                winCallback={winCallback}
                itemCallback={itemCallback}
            />
        </div>
    );
}
